import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
interface SocialProofPopupProps {
  show: boolean;
  name: string;
  city: string;
}
export function SocialProofPopup({
  show,
  name,
  city
}: SocialProofPopupProps) {
  return <AnimatePresence data-id="element-269">
      {show && <motion.div initial={{
      x: -400,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -400,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 100
    }} className="fixed bottom-6 left-6 bg-white rounded-lg shadow-2xl p-4 max-w-sm z-50 border-2 border-green-500" data-id="element-270">
          <div className="flex items-start gap-3" data-id="element-271">
            <CheckCircleIcon className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" data-id="element-272" />
            <div data-id="element-273">
              <p className="font-bold text-gray-900" data-id="element-274">{name}</p>
              <p className="text-sm text-gray-600" data-id="element-275">de {city}</p>
              <p className="text-sm text-green-600 font-semibold mt-1" data-id="element-276">
                acaba de comprar este programa
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}
export default SocialProofPopup;